import api from '../api.js';
import { flatten, getTopIndex } from '../../versa/record.js';
import * as types from '../types.js';

export default {

	html: `
		<style>
			#output #company_id				{ width: 10rem;		}
			#output #id						{ width: 5.5rem; text-align: right;	}
			#output #order_id				{ width: 5.5rem; text-align: right;	}
			#output #order_type				{ width: 10rem;		}
			#output #warehouse_company_id 	{ width: 10rem;		}
			#output #warehouse_id			{ width: 10rem;		}
			#output #created_on				{ width: 10rem;		}
			#output #expedited_on			{ width: 10rem;		}
			#output #volume_type			{ width: 10rem;		}
			#output #volumes				{ width: 5rem; text-align: right;	}
			#output #weight					{ width: 6rem; text-align: right;	}
			#output #status	 				{ width: 10rem;		}
			#output .location 				{ width: 5rem;		}
			#output .product 				{ width: 25rem;		}
			#output .lot 					{ width: 8rem;		}
			#output .quantity 				{ width: 4.5rem; text-align: right;	}
			#output .discount 				{ width: 4rem; text-align: right; 	}
			#output .price 					{ width: 6.5rem; text-align: right;	}
		</style>
		<form id="output" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="warehouses">
			</datalist>
			<datalist id="locations">
			</datalist>
			<datalist id="products">
			</datalist>
			<datalist id="programs">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador da saída">Saída
					<input id="id" type="text" disabled>
				</label>
				<label title="Número do pedido vinculado">Pedido<sup>*</sup>
					<input id="order_id" type="text" required>
				</label>
				<label title="Tipo do pedido vinculado">Tipo<sup>*</sup>
					<input id="order_type" type="text" list="order_types" value="I" disabled>
				</label>
				<label title="Programa da saída (do pedido)">Programa
					<input id="program_id" type="text" list="programs" disabled>
				</label>
				<label title="Referência do pedido">Referência
					<input id="reference" type="text" disabled>
				</label>
				<label title="Data e hora de criação da saída">Criação
					<input id="created_on" type="text" disabled>
				</label>
				<label title="Data e hora de expedição da saída">Expedição
					<input id="expedited_on" type="text" disabled>
				</label>
			</div>
			<div class="fsb">
				<label title="Empresa do armazém de coleta">Remetente<sup>*</sup>
					<input id="warehouse_company_id" type="text" list="companies" required>
				</label>
				<label title="Armazém de coleta">Armazém<sup>*</sup>
					<input id="warehouse_id" type="text" list="warehouses" required>
				</label>
				<label title="Tipo de volumes">Tipo Volumes
					<input id="volume_type" type="text" list="volume_types" value="C">
				</label>
				<label title="Número de volumes">Volumes
					<input id="volumes" type="text">
				</label>
				<label title="Peso total dos volumes">Peso
					<input id="weight" type="text">
				</label>
				<label title="Status da saída">Status<sup>*</sup>
					<input id="status" type="text" list="output_status" value="10" required>
				</label>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<th></th>
							<th>Posição<sup>*</sup></th>
							<th>Produto<sup>*</sup></th>
							<th>Lote<sup>*</sup></th>
							<th>Qt Req<sup>*</sup></th>
							<th>Qt Forn</th>
							<th>% Desc</th>
						</tr>
					</thead>
					<tbody>
						<tr class="row">
							<td>
								<input id="checkbox-0" type="checkbox">
							</td>
							<td title="Posição de coleta no armazém">
								<input id="location_id-0" class="location" type="text" list="locations" required>
							</td>
							<td title="Produto">
								<input id="product_id-0" class="product" type="text" list="products" required>
							</td>
							<td title="Lote do produto">
								<input id="lot_id-0" class="lot" type="text" list="lots-0" required>
							</td>
							<td title="Quantidade pendente para envio">
								<input id="quantity_required-0" class="quantity" type="text" required>
							</td>
							<td title="Quantidade fornecida nesta saída">
								<input id="quantity_supplied-0" class="quantity" type="text">
							</td>
							<td title="Desconto atribuído ao produto">
								<input id="discount-0" class="discount" type="text" disabled>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span>
					<!--
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de seleção">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conteúdo das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
					-->
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,

	form: 
	{
		selector: '#output',
		init(formset)	// Must not be async as init seq must be preserved
		{
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			formset.loadList('#programs', 'programs', { labels: ['name'], value: 'id' });
			this.getFieldByName('company_id').subscribe(['change'], this.checkCondition.bind(formset), false);	// once = false
			this.getFieldByName('order_id').subscribe(['change'], this.checkCondition.bind(formset), false);	// once = false
			Object.getPrototypeOf(this).init.call(this);
		},
		checkCondition(ev, publisher, value)
		{
			let company_id = this.form.getFieldByName('company_id').getValue();
			let order_id = this.form.getFieldByName('order_id').getValue();
			let key = String([company_id, order_id])
			if (typeof company_id != 'string' || !order_id || key == this.last_key)
				return;
			let is_edit = this.form.getFieldByName('id').getValue();
			if (!is_edit || (is_edit && this.last_key))		// If insert (no id) fill it now; If edit (has id) fill it only after 2nd change (has last_key)
				this.form.fillItems.call(this, company_id, order_id);
			this.last_key = key;
		},
		async fillItems(company_id, order_id)
		{
			let record = await api.call(api.select_input_order, company_id, order_id);
			if (!record)
				return
			record.items = record.items.map(item => { item.quantity_required = item.quantity; return item; });
			record = flatten(record, 'items');
			this.clearAllRows();
			this.appendRows(getTopIndex(record) - this.getEnabledRowsIndices().length + 1);
			this.form.setValues(record);
			this.form.refresh();
		},
	},
	
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#order_id' }, types: [types.pubsub(), types.number(0, 2)] },
		{ properties: { selector: '#order_type' }, types: [types.pubsub(), types.opt_order_type(), types.datalist()] },
		{ properties: { selector: '#program_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#reference' }, types: [] },
		{ properties: { selector: '#created_on' }, types: [types.datetime()] },
		{ properties: { selector: '#expedited_on' }, types: [types.datetime()] },
		{ properties: { selector: '#warehouse_company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#warehouse_id' }, types: [types.pubsub(), types.datalist(), types.observer('warehouse_company_id'), types.obs_load_options('warehouses')] },
		{ properties: { selector: '#volume_type' }, types: [types.opt_volume_type(), types.datalist()] },
		{ properties: { selector: '#volumes' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#weight' }, types: [types.number(3)] },
		{ properties: { selector: '#status' }, types: [types.opt_output_status(), types.datalist()] },
		{ properties: { selector: '#checkbox-0' }, types: [types.checkbox()] },
		{ properties: { selector: '#location_id-0' }, types: [types.pubsub(), types.datalist(), types.observer('warehouse_id'), types.obs_load_options('locations', { labels: ['address'], sep: '-', key: 'warehouse_company_id' })] },
		{ properties: { selector: '#product_id-0' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('products', { labels: ['sku', 'name'] })] },
		{ properties: { selector: '#lot_id-0' }, types: [types.pubsub(), types.datalist(), types.observer('product_id-0'), types.obs_load_options('lots', { labels: ['lot_number'], key: 'company_id', range: 1 })] },
		{ properties: { selector: '#quantity_required-0' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#quantity_supplied-0' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#discount-0' }, types: [types.number(2)] },
	]

};

